export const contentfulLanguagesMap = {
    en: 'en-US',
    ar: 'ar',
    tr: 'tr',
};
export const parseLangCountry = (pathname, supportedLanguages) => {
    const [, maybeLangCountry] = pathname.toLowerCase().split('/');
    const supportedLocalesSet = new Set(supportedLanguages);
    if (maybeLangCountry) {
        const countryLangRegexp = /^[a-z]{2}-[a-z]{2}$/;
        if (countryLangRegexp.test(maybeLangCountry)) {
            const [lang, country] = maybeLangCountry.split('-');
            if (supportedLocalesSet.has(lang)) {
                return { lang, country };
            }
        }
        else if (supportedLocalesSet.has(maybeLangCountry)) {
            return { lang: maybeLangCountry };
        }
    }
    return;
};
export const removeLangCountry = (pathname) => {
    // country is optional
    const countryLangRegexp = /^[a-z]{2}(-[a-z]{2})?$/i;
    const [, maybeLangCountry, ...rest] = pathname.split('/');
    const cleanUrl = [countryLangRegexp.test(maybeLangCountry) ? '' : `/${maybeLangCountry}`, ...rest].join('/');
    return cleanUrl === '' ? '/' : cleanUrl;
};
export const getLangDirection = (locale) => {
    if (locale === 'ar')
        return 'rtl';
    return 'ltr';
};
export const createPathname = (pathname, params) => {
    const cleanedPathname = removeLangCountry(pathname);
    if (params === null || params === void 0 ? void 0 : params.country) {
        return `/${params.lang}-${params.country.toLowerCase()}${cleanedPathname === '/' ? '' : cleanedPathname}`;
    }
    if (params === null || params === void 0 ? void 0 : params.lang) {
        return `/${params.lang}${cleanedPathname === '/' ? '' : cleanedPathname}`;
    }
    return cleanedPathname;
};
